/**
 * @file QSightBasicMetricCard.tsx
 * @description This file contains the QSightMetricCard component, which is used to display a metric card with a title, subtitle, and value.
 * @param, title, subtitle, value, error
 */

import React from 'react';
import { Card, CardBody, CardHeader, Spinner } from 'reactstrap';
import './QSightBasicMetricCard.style.css';
import '../QSightMetricCard.common.css';

export interface MetricCardValue {
    subtitle: string;
    value: string | number;
}

export interface QSightBasicMetricCardProps {
    metricId?: number;
    title: string;
    DataValues: [MetricCardValue, MetricCardValue];
    error?: string;
    loading?: boolean;
}

const QSightBasicMetricCard: React.FC<QSightBasicMetricCardProps> = ({
    title,
    DataValues,
    error,
    loading = false,
}) => {
    const isValidData = Array.isArray(DataValues) && DataValues.length === 2;

    const renderTitle = () => {
        return <div className="metric-card-title bg-white text-primary">{title && title?.trim() !== '' ? title?.trim() : 'No Title Found!'}</div>;
    };

    const renderError = () => (
        <div className="text-danger">
            <strong>Error:</strong> {error}
        </div>
    );

    const renderWarning = () => (
        <div className="text-warning">
            <strong>Warning:</strong> Invalid data format.
        </div>
    );

    const renderLoading = () => (
        <div className="text-center py-3">
            <Spinner color="primary" />
        </div>
    );

    const renderValues = () => (
        <div className="metric-values">
            {DataValues.map((data, index) => (
                <div key={index} className="metric-item mx-1 mb-2">
                    <div className="metric-value text-primary">{data.value && data.value !== '' ? data.value : <div className='small'>{'No Data'}</div>}</div>
                    {data.subtitle?.trim() && (
                        <div className="metric-label text-primary">{data.subtitle?.trim()}</div>
                    )}
                </div>
            ))}
        </div>
    );

    return (
        <Card className="qsight-metric-card basic-metric-card border-primary">
            <CardBody className='p-2'>
                <CardHeader className="my-0 mx-5 p-0 bg-white border-0">{renderTitle()}</CardHeader>
                {loading
                    ? renderLoading()
                    : error
                        ? renderError()
                        : !isValidData
                            ? renderWarning()
                            : renderValues()}
            </CardBody>
        </Card>
    );
};

export default QSightBasicMetricCard;



